import { axios } from "lib/axios";

export const signInWithGoogleCallback = ({ code, scope }) => {
  return axios.get(`/auth/google/callback?code=${code}&scope=${scope}`);
};
